import React, { useState } from 'react';

function CardMarca({ marca }) {
  const [productos, setProductos] = useState(marca.Productos);
  
  return (
    <div className='w-full max-w-xs flex flex-col items-center shadow-cardsuave m-3 rounded-lg overflow-hidden bg-Blanco'>
      {/* Contenedor de la imagen */}
      <div className='w-full h-40 flex items-center justify-center p-3'>
        <img src={marca.Imagen} className='w-full h-full object-contain' alt={marca.Titulo} />
      </div>
      
      {/* Contenedor del texto */}
      <div className='w-full flex flex-col items-center p-3'>
        <h2 className='text-Negro text-center text-xl font-bold truncate'>{marca.Titulo}</h2>
        <p className='text-bsm text-GrisOscuro text-center font-semibold italic mt-2 overflow-hidden text-ellipsis'>
          "{marca.Descripcion}"
        </p>
      </div>
    </div>
  );
}

export default CardMarca;
